export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE ";
export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const GET_EMPLOYEE_BY_ID = "GET_EMPLOYEE_BY_ID";
export const GET_EMPLOYEE_SCHEDULE = "GET_EMPLOYEE_SCHEDULE"